import { CropFree, ZoomInMap } from "@mui/icons-material";
import { Autocomplete, Avatar, Backdrop, Button, Grid, IconButton, TextField, Typography } from "@mui/material";
import React, { memo, useEffect, useRef, useState } from "react";
import { useStyle } from "../style";
import BillingTable from "./billingTable";
import CustomerInfo from "./customerInfo";
import PurchaseInfo from "./purchaseInfo";
import SearchItem from "./searchItem";
import Logo from "../../../../../assets/images/Girlush Logo.png"
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Invoice from "../../../../../components/utils/invoicePage/invoice";
import SearchIcon from '@mui/icons-material/Search';
const Purchase = () => {
  const classes = useStyle();
  const fullscreenRef = useRef(null);
  const codeRef = useRef(null)
  const [isFull, setIsFull] = useState(false);
  const [data, setData] = useState([])
  const [code,setCode] = useState('')
  const [flag, setFlag] = useState(false)
  const [open, setOpen] = useState(true)
  const [docName , setDocName] = useState("")

  const navigate = useNavigate()
  const[postData , setPostData] = useState({
      docdate: "", 
      partycode:"",
      amount: "",
      subtotal_amount: "",
      gst_per: "",
      gst_amt: "",
      cess_per: "",
      cess_amt: "",
      roff: "",
      freight_charges: "",
      other_charges:"",
      partydcdate: "",
      partydc: "",
      outstanding: "",
      company_id: "",
      po_details: [],
      purchase_details: []
  })

  const toggleFullscreen = () => {
   const isFullScreen = document.fullscreenElement
if(isFullScreen){
  document.exitFullscreen()
  setIsFull(!isFull)
}
else{
  fullscreenRef.current.requestFullscreen();
  setIsFull(!isFull)
}
  };
  
  useEffect(() => {
    const checkFullscreen = () => {
      const isFullScreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
      setIsFull(!!isFullScreen);
    };
  
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        checkFullscreen();
      }
    };
  
    document.addEventListener('fullscreenchange', checkFullscreen);
    document.addEventListener('mozfullscreenchange', checkFullscreen);
    document.addEventListener('webkitfullscreenchange', checkFullscreen);
    document.addEventListener('msfullscreenchange', checkFullscreen);
    document.addEventListener('keydown', handleEscapeKey);
  
    return () => {
      document.removeEventListener('fullscreenchange', checkFullscreen);
      document.removeEventListener('mozfullscreenchange', checkFullscreen);
      document.removeEventListener('webkitfullscreenchange', checkFullscreen);
      document.removeEventListener('msfullscreenchange', checkFullscreen);
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [setIsFull]);


  return (
    <Grid ref={fullscreenRef} className={classes.root}>
      <Helmet><title>Purchase</title></Helmet>
      <Grid className={classes.titleInfo} sx={{paddingBlock:"25px"}}>
        <Grid className="flex justify-between items-center">
          <Avatar variant="square" src={Logo} onClick={() => navigate('/dashboard')} sx={{cursor:"pointer",}}/>
          <Typography  fontWeight={600} ml={1} onClick={() => navigate('/dashboard')} sx={{cursor:"pointer",fontSize:20}}>GIRLUSH</Typography>
        </Grid>
        <Typography variant="h5" fontWeight={600}>Purchase</Typography>
      <Grid>
        <Button onClick={()=>setFlag(true)} sx={{color:"#000 !important"}}><SearchIcon /> Search code</Button>
        {/* {isFull ? <IconButton onClick={toggleFullscreen}><ZoomInMap /></IconButton>
         : <IconButton onClick={toggleFullscreen}><CropFree /></IconButton>} */}
      </Grid>
      </Grid>
      <Grid className={classes.contentGrid}>
        <Grid className="w-5/6" sx={{display: 'flex', flexDirection:'column',  flex: 1,}}>
          <Grid className="border-b" sx={{height:'fit-content'}}><PurchaseInfo setPostData={setPostData}  postData={postData} setDocName={setDocName} docName={docName}/></Grid>
          <Grid className="p-2 " sx={{flex:1, height:'100%',maxHeight:"80%" , overflow:"auto"}}><BillingTable data={data} setData={setData} code={code} setCode={setCode} ref={codeRef} setPostData={setPostData} /></Grid>
       
        </Grid>
        <Grid className="w-1/6 h-full border-l py-2">
          <Grid className="border-b px-3">
            <CustomerInfo data={data} setData={setData} postData={postData} setPostData={setPostData} setDocName={setDocName} docName={docName}/>
          </Grid>
        </Grid>
      </Grid>
      <Backdrop open={flag} sx={{zIndex:1100,}} >
          <SearchItem setFlag={setFlag} forwardRef={codeRef} setCode={setCode}/>
        </Backdrop>
        {/* <Backdrop open={open} sx={{zIndex:1100,}} >
        <div className="w-3/4 h-3/4 overflow-scroll"> <Invoice /></div>
        </Backdrop> */}
    </Grid>
  );
};

export default memo(Purchase);
